var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialistCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.5C22.18 17.5 18.5 18.42 18.5 20.26V29.5H21.5V38.5H26.5V29.5H29.5V20.26C29.5 18.44 25.82 17.5 24 17.5ZM24 4.5C12.94 4.5 4 13.44 4 24.5C4 35.56 12.94 44.5 24 44.5C35.06 44.5 44 35.54 44 24.5C44 13.46 35.04 4.5 24 4.5ZM24 40.5C15.16 40.5 8 33.34 8 24.5C8 15.66 15.16 8.5 24 8.5C32.84 8.5 40 15.66 40 24.5C40 33.34 32.84 40.5 24 40.5Z",
    fill: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5C25.6569 16.5 27 15.1569 27 13.5C27 11.8431 25.6569 10.5 24 10.5C22.3431 10.5 21 11.8431 21 13.5C21 15.1569 22.3431 16.5 24 16.5Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialistCare);
export default __webpack_public_path__ + "static/media/specialist-care.ab070276e110ab452f1696d52f472f9e.svg";
export { ForwardRef as ReactComponent };